<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <h4 class="text-h4">Supplier Payments</h4>
                <p class="text-subtitle-1">List of supplier payments</p>
            </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row class="my-1">
            <v-col cols="12" md="3">
                <v-btn class="primary" block @click="handleNew" v-if="hasPermission(perm.payment.create)">
                    <v-icon left>mdi-plus</v-icon>
                    new payment
                </v-btn>
            </v-col>
            <v-col cols="12" md="3">
                <v-menu offset-y :close-on-content-click="false">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            block
                            depressed
                            v-bind="attrs"
                            v-on="on"
                            >
                            <v-icon left>mdi-magnify</v-icon>
                            Search
                        </v-btn>
                    </template>
                    <v-card 
                        flat
                        >
                        <v-card-title>Search</v-card-title>
                        <v-card-text>
                            <PurchasePaymentListSearch ref="form"/>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn  color="primary" block @click="$refs.form.submit()">Submit</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-menu>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <PurchasePaymentList/>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import PurchasePaymentListSearch from './../../../src/components/purchase/PurchasePaymentListSearch.vue';
import {mapGetters} from 'vuex';
import permissions from './../../data/permissions';
import PurchasePaymentList from '@/components/purchase/PurchasePaymentList';

export default {
    name: "PurchasePaymentListView",
    components: {
        PurchasePaymentList,
        PurchasePaymentListSearch
    },
    data() {
        return {
            perm: permissions
        }
    },
    computed: {
        ...mapGetters({
            hasPermission: "authentication/hasPermission"
        })
    },
    methods: {
        handleNew() {
            this.$router.push({ name: "PurchasePaymentCreate" })
        }
    }
}
</script>

<style>

</style>